// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"141d90f3","843":"4c0ed8a7"}[chunkId] + ".chunk.css";
};